export const CHECKOUT_SELECTION_KEY = 'dntech_checkout_selection';

export function saveCheckoutSelection(ids: Array<string | number>) {
  if (typeof window === 'undefined') return;

  const normalizedIds = ids.map((id) => String(id).trim()).filter(Boolean);

  try {
    if (normalizedIds.length) {
      sessionStorage.setItem(CHECKOUT_SELECTION_KEY, JSON.stringify(normalizedIds));
    } else {
      sessionStorage.removeItem(CHECKOUT_SELECTION_KEY);
    }
  } catch {
    // ignore storage errors
  }
}
